import vue from 'vue';
import get from 'lodash.get';
import merge from 'lodash.merge';

const Vue = vue.default || vue;

export default {
	SET_APP(state, payload = {}) {
		state.app = merge({}, state.app, payload);
	},
	SET_ERROR(state, error = {}) {
		// Load nested error in case of makeRequest error wrapping
		const errorFromMakeRequest = get(error, 'app.detail.response.body.error');
		const errorObject = Object.assign({}, errorFromMakeRequest || error);
		// Add missing properties which are required in templates
		errorObject.app = errorObject.app ?? {};
		errorObject.app.status = errorObject.app.status ?? 500;
		state.error = Object.assign({}, errorObject);
	},
	SET_THEME(state, theme = {}) {
		state.theme = Object.assign({}, theme);
	},
	SET_PAGE(state, page = {}) {
		state.page = Object.assign({}, page);
	},
	SET_URL(state, url = {}) {
		state.url = Object.assign({}, url);
	},
	SET_FORM(state, form = {}) {
		state.form = merge({}, state.form, form);
	},
	SET_ACCOUNT(state, account = {}) {
		state.account = Object.assign({}, account);
	},
	SET_OFFER(state, { offerCookie, isMobile = false }) {
		state.shouldGetOffer = Boolean(state.order?.impressions.length && offerCookie !== state.app?.session?.id && !isMobile && !state.order?.isOmsFlow);
	},
	SET_CUSTOMER(state, customer = {}) {
		state.customer = Object.assign({}, customer, {
			billing: {
				...customer.billing,
				phoneNumber: customer.billing.phoneNumber.replace(/\D/g, '') // Remove anything but digits
			}
		});
	},
	SET_PAYMENT(state, payment = {}) {
		state.payment = Object.assign({}, payment);
	},
	SET_SELECTED_PAYMENT(state, selectedPayment = {}) {
		const paymentMethod = state.payment.paymentMethods.find((paymentMethod) => paymentMethod.id === selectedPayment.type);
		state.selectedPayment = Object.assign({}, state.selectedPayment, paymentMethod, selectedPayment);
	},
	SET_ORDER(state, order = {}) {
		state.order = Object.assign({}, order);
		state.isEmpty = state.order.productsCount === 0;
	},
	SET_PROVIDER(state, provider = {}) {
		state.provider = merge({}, state.provider, provider);
	},
	SET_PROVIDER_ACCOUNT(state, providerAccount = {}) {
		state.providerAccount = Object.assign({}, providerAccount);
	},
	SET_LOCALIZATION(state, localization = {}) {
		state.localization = Object.assign({}, localization);
	},
	SET_COMPANY(state, status) {
		state.isCompany = status;
	},
	SET_LOADER(state, status) {
		state.isLoading = status;
	},
	SET_NEW_METHOD(state, status) {
		state.isNewMethod = status;
	},
	SET_NEW_CART(state, status) {
		state.isNewCart = status;
	},
	SET_TERMS_AGREEMENT(state, terms = {}) {
		state.terms = Object.assign({}, terms);
	},
	SET_ACTIVATION(state, { id, status, successCount, failCount } = {}) {
		const product = state.order.products.find((product) => {
			return product.id === id;
		});
		Vue.set(product.fulfillment, 'activation', {
			status,
			successCount,
			failCount
		});
	},
	SET_RETARGETING_URL(state, url) {
		state.retargetingUrl = url;
	},
	SET_ONLINE(state, status) {
		state.connectionIsOnline = status;
	},
	SET_MODAL(state, modalName) {
		state.modal = state.modal === modalName ? '' : modalName;
	},
	SET_POLYFILLS(state, polyfills) {
		state.polyfills = Object.assign({}, state.polyfills, polyfills);
	},
	SET_META(state, meta) {
		state.meta = Object.assign({}, meta);
	},
	SET_ZIP_VALIDATION_STATE(state, newState = 'done') {
		state.zipCodeState = newState;
	},
	SET_PAYMENT_GATEWAY_PROVIDER_URL(state, paymentGatewayProviderUrl = '') {
		state.paymentGatewayProviderUrl = paymentGatewayProviderUrl;
	}
};
